var indentation_default = {
  "indentZero": "Q8S2H",
  "indentOne": "YYF8s",
  "indentTwo": "_1f4Rb",
  "indentThree": "Ej16g",
  "indentFour": "_9EdiZ",
  "indentFive": "cr1GN",
  "indentSix": "clTrt"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
